import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Register Service Worker for PWA functionality - non-blocking
if ('serviceWorker' in navigator) {
  // Register immediately without waiting for load event
  navigator.serviceWorker.register('/sw.js')
    .then(registration => {
      // Wait for service worker to be ready but don't block app rendering
      registration.addEventListener('updatefound', () => {
        const installingWorker = registration.installing;
        installingWorker.addEventListener('statechange', () => {
          if (installingWorker.state === 'activated') {
            // Service worker activated - silent for production
          }
        });
      });
    })
    .catch(error => {
      //console.log('ServiceWorker registration failed: ', error);
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
